var $ = require('jquery');
var siteadmin = require('./siteadmin');

(function() {

    /** reference to the site admin */
    var getSiteAdmin = function() {
        return siteadmin;
    };

    /**
     * Retrieves current window object
     *
     * @returns {*|CKEDITOR.dom.window}
     */
    this.getWindow = function () {
        return getSiteAdmin().getController().getWindow();
    };

    /**
     * Modifies window behavior settings of current window with provided data
     *
     * @param {Object} windowBehavior
     */
    this.updateWindowBehavior = function(windowBehavior) {
        this.getWindow().setBehavior(windowBehavior);
    };

    /**
     * updates the content's id from the siteadmin
     *
     * @param {String} title the title to set
     */
    this.updateID = function (id) {
        getSiteAdmin().getController().updateID(id);
    };

    /**
     * updates the content's title from the header area
     *
     * @param {String} title the title to set
     */
    this.updateTitle = function(title) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateTitle(title);
        }
//        getSiteAdmin().getController().updateTitle(title);
    };

    /**
     * updates the content's description from the header area
     *
     * @param {String} descr the description to set
     */
    this.updateDescr = function(descr) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.updateDescr(descr);
        }
//        getSiteAdmin().getController().updateDescr(descr);
    };

    /**
     * updates the content's navigation tabs
     *
     * @param {Array} navi the html structure of the tabs
     *      Array should be an array of objects with the following parameters:
     *      {
     *          id:    'mytabid',
     *          text:  'Click this tab',
     *          url:   'http://my.absolute.url/my.page'
     *      }
     */
    this.updateNavi = function (navi) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateNavi(navi);
        }
    };

    /**
     * Shows the navigation including tabs
     */
    this.showNavi = function () {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.showNavi();
        }
    };

    /**
     * Hides the navigation including tabs
     */
    this.hideNavi = function () {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.hideNavi();
        }
    };

    this.openActiveController = function() {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.show();
        }
    };

    /**
     * updates the buttons of the window with an object containing desired buttons
     *
     * @param {Object} buttons the buttons properties
     *              {
     *                  close: {
     *                      text: 'Close',
     *                      event: 'closeButtonClicked'
     *                  },
     *                  secondary: {
     *                      text: 'Secondary',
     *                      event: 'secondaryButtonClicked',
     *                  },
     *                  primary: {
     *                      text: 'Primary',
     *                      event: 'primaryButtonClicked',
     *                  },
     *                  checkbox: {
     *                      text: 'Checkbox',
     *                      event: 'checkboxClicked',
     *                  }
     *              }
     */
    this.updateButtons = function(buttons) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateButtons(buttons);
        }
    };

    /**
     * triggers a menu item action, just as if clicked by the user
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.triggerMenuItem = function(id, params) {
        var elem = $('#' + id);
        if (!elem.length) {
            return;
        }
        var specificController = (elem.attr('data-params') || "").split(',')[0].trim();

        getSiteAdmin().sidebarItemClick.call(elem.get(0), 'apiEvent', specificController, params);
    };

    /**
     * internal helper method for set visual active item
     */
    var internalSetSidebarActiveItem = function(id) {
        if ('string' === typeof id) {
            id = $('#' + id).get(0);
        }

        getSiteAdmin().setSidebarActiveItem(id);
        return id;
    };

    /**
     * updates the site admin's active item and record item in history without triggering its action
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.setSidebarActiveItem = function(id) {
        id = internalSetSidebarActiveItem(id);
        $(id).historyManager("addRecordOnly");
    };

    /**
     * updates the site admin's active item visual
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.setSidebarVisualActiveItem = function(id) {
        internalSetSidebarActiveItem(id);
    };

    /**
     * updates the site admin's window navigation (tabs) active state
     *
     * @param id {String|Number} if it's a string, it will use the "identifier" parameter
     *                           of the navigation link, if it's a number it will be that index
     */
    this.setNaviActiveItem = function(id) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.setNaviActiveItem(id);
        }
    };

    /**
     * Collapses/expands the siteadmin sidebar
     *
     * @param {boolean} show whether should be shown
     * @param {boolean} noAnimation whether should use animation or not
     */
    this.toggleSidebar = function(show, noAnimation) {
        getSiteAdmin().toggleSidebar(show, noAnimation);
    };

    this.isSidebarMinimized = function() {
        return getSiteAdmin().isSidebarMinimized();
    };

    this.disableCache = function()
    {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.disableCache();
        }
    };

    /**
     * updates the content's save button
     *
     * @param {String} str the string to update the save button with
     */
    this.updateSaveBtn = function(str, callback) {
        getSiteAdmin().getController().updateSaveBtn(str, callback);
    };

    /**
     * shows/hide the loading indicator
     *
     * @param {String} str hide or show
     */
    this.loading = function(str) {
        getSiteAdmin().getController().loading(str);
    };
    /**
     * shows/hide the smaller loading indicator (under the close button)
     *
     * @param {boolean} status hide or show
     * @param {int} bottomDistance Optionally override the distance to the bottom of the container.
     * @param {int} rightDistance Optionally override the distance to the right of the container.
     */
    this.smallLoading = function(status, bottomDistance, rightDistance) {
        var controller = getSiteAdmin().getController();
        if (controller !== null) {
            getSiteAdmin().getController().smallLoading(status, bottomDistance, rightDistance);
        }
    };

    this.saveBtnClicked = function(a,b,c) {
        getSiteAdmin().getController().saveBtnClicked(a,b,c);
    };

    this.showWindow = function(src, windowBehavior, contentType, controller, controllerId) {
        getSiteAdmin().showWindow(src, windowBehavior, contentType, controller, controllerId);
    };

    this.getHeaderData = function(src) {
        var a = getSiteAdmin();
        if (a) {
            var c = a.getController();
            if (c) {
                return c.getHeaderData();
            }
        }
    };

    this.close = function(preventDefault, skipCacheCheck) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.close(preventDefault, skipCacheCheck);
        }
    };

    this.show = function() {
        getSiteAdmin().show();
    }

    this.hide = function() {
        getSiteAdmin().hide();
    }

    this.destroyController = function(controllerID, withClose) {
        getSiteAdmin().destroyController(controllerID, withClose);
    };

    this.updateHelpTopic = function(topic) {
        getSiteAdmin().getController().updateHelpTopic(topic);
    };

    this.updateFeatureGuidanceHelp = function(stepId) {
        getSiteAdmin().getController().updateFeatureGuidanceHelp(stepId);
    };

    this.activateCallout = function(elementId, calloutData) {
        getSiteAdmin().activateCallout(elementId, calloutData);
    };
    this.closeCallout = function(elementId) {
        getSiteAdmin().closeCallout(elementId);
    };
    /**
     * shows THE callout for THE new feature
     */
    this.activateNewFeatureCallout = function(){
        getSiteAdmin().activateNewFeatureCallout();
    };
    this.getMinMaxState = function(){
        return getSiteAdmin().getMinMaxState();
    };
    this.disableCalloutFeature = function(featureId) {
        getSiteAdmin().disableCalloutFeature(featureId);
    };

    this.buttonEnable = function (buttonId){
        return getSiteAdmin().buttonEnable(buttonId);
    };

    this.buttonDisable = function (buttonId){
        return getSiteAdmin().buttonDisable(buttonId);
    };

    this.setParams = function (params) {
        return getSiteAdmin().setParams(params);
    };

    this.getParams = function () {
        return getSiteAdmin().getParams();
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/api.js
 ** module id = 19
 ** module chunks = 0
 **/